<template>
    <div class="group">
        <strong>{{title}}</strong>
        <Dropdown
                v-for="dropdown in dropdownsWithValues"
                v-bind:key="dropdown.name"
                v-bind:options="dropdown.values"
                v-on:input="$emit('input', [dropdown.name, $event])"
        />
    </div>
</template>

<script>
    import Dropdown from "./Dropdown";
    export default {
        name: "Group",
        components: {Dropdown},
        props: ['title', 'dropdowns'],
        computed: {
            dropdownsWithValues: function () {
                return this.dropdowns.filter(v => v.values.length)
            }
        }
    }
</script>

<style scoped>
    .group {
        padding: 4px 2px;
        color: #FFFFFF;
        background: #64983d;
        font-size: 1.25rem;
        margin-bottom: 1px;
        line-height: 1;
    }
</style>
